@media screen and (max-width: 768px) {
  .ugc-global-css-wrap.isDesktop{
    display: none !important;
  }
}
